import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {Product} from '../../model/Entities/Product';
import {FormControl, Validators} from '@angular/forms';
import {numberValidator} from '../../validators/number.validator';
import {intValidator} from '../../validators/int.validator';

@Component({
    selector: 'product-labels-print-dialog',
    templateUrl: './product-labels-print.dialog.component.html',
    styleUrls: ['./product-labels-print.dialog.component.scss']
})
export class ProductLabelsPrintDialogComponent {

    count = 0;
    copies = 1;

    countFC = new FormControl('', [
        Validators.required,
        Validators.min(0),
        intValidator()
    ]);

    copiesFC = new FormControl('', [
        Validators.required,
        Validators.min(1),
        intValidator()
    ]);

    constructor(public dialog: MatDialogRef<ProductLabelsPrintDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    checkValidity(): boolean {
        return this.countFC.valid
            && this.copiesFC.valid;
    }
}



// WEBPACK FOOTER //
// /app/src/ProductsModule/ProductLabelsPrintDialogComponent/product-labels-print.dialog.component.ts